"use client";
import Script from "next/script";

const oneTrustId = "be1773a2-88cc-4e84-9079-28f4803c1a53";

export default function OneTrustSetup() {
  return (
    <>
      {/* "For our Secured Loan CRM journey we hide onetrust as user is only in dashboard project for authorisation and redirection to Ocean website." */}
      <Script
        src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={oneTrustId} /><Script type="text/javascript" id="oneTrustWrapper">
          {`
            function OptanonWrapper() {
          }
        `}
        </Script>
      {process.env.NODE_ENV === "production" && (
        <Script type="text/javascript" id="dataDogLogging">
          {`
            const isProduction = location.host === 'dashboard.credability.co.uk';

            !(function (h, o, u, n, d) {
              (h = h[d] =
                h[d] || {
                  q: [],
                  onReady: function (c) {
                    h.q.push(c);
                  },
                }),
                ((d = o.createElement(u)).async = 1),
                (d.src = n),
                (n = o.getElementsByTagName(u)[0]).parentNode.insertBefore(d, n);
            })(
              window,
              document,
              'script',
              'https://www.datadoghq-browser-agent.com/us1/v5/datadog-logs.js',
              'DD_LOGS'
            ),
              window.DD_LOGS.onReady(function () {
                window.DD_LOGS.init({
                  clientToken: 'pube615325bb043ce6c9f21e8c8b3ba2c4e',
                  site: 'datadoghq.eu',
                  service: 'credability.website.loggedin_dashboard',
                  env: isProduction ? 'prod' : 'test',
                  forwardErrorsToLogs: false
                });
              });
            `}
        </Script>
      )}
    </>
  );
}
